import React from 'react';

export default () => (
  <div className='page preloader'>
    <div className='page-title'></div>
    <div className='scheduler'>
      <div className='scheduler__left'>
        <div className='mock1'></div>
        <div className='mock2'></div>
      </div>
      <div className='scheduler__right'></div>
    </div>
  </div>
)